import React from 'react'
import type { DateHeaderProps } from 'react-big-calendar'
import { makeStyles, Typography } from '@paintscout/ui'
import classNames from 'classnames'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    color: theme.palette.text.primary,
    padding: theme.spacing(1),
    zIndex: 1000,
    position: 'relative'
  },
  label: {
    margin: 0,
    cursor: 'pointer',
    pointerEvents: 'auto',
    fontSize: theme.typography.pxToRem(12),
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: '#eaf6ff',
      boxShadow: 'none'
    }
  },
  today: {
    position: 'relative',
    backgroundColor: theme.paintscout.palette.primary,
    borderRadius: '50%',
    boxShadow: `0 0 0 3px ${theme.paintscout.palette.primary}`,
    width: '16px',
    height: '16px',
    color: 'white'
  }
}))

export function MonthDateHeader(props: DateHeaderProps) {
  const classes = useStyles()
  const { onDrillDown, label, date, isOffRange } = props
  const isToday = new Date().toDateString() === date.toDateString()
  if (isOffRange) {
    return null
  }

  return (
    <Typography className={classes.root} component={'div'} variant="body2" color="textSecondary" align="center">
      <p className={classNames({ [classes.label]: true, [classes.today]: isToday })} onClick={onDrillDown}>
        {label}
      </p>
    </Typography>
  )
}
